import React from "react";
import Navbar from "./components/NavbarPage/Navbar";
import Home from "./components/HomePage/Home";
import Purpose from "./components/PurposePage/Purpose";
import About from "./components/AboutPage/About";
import ImageGallery from "./components/ImageGalleryPage/ImageGallery";
import Contact from "./components/ContactPage/Contact";
import "./App.css";

const App = () => {
  return (
    <div className="App">
      {/* Header navigation */}
      <header>
        <Navbar />
      </header>

      <div id="home">
        <Home />
      </div>

      <div id="about">
        <About />
      </div>

      <div className="parallax-section">
      </div>

      <div id="purpose">
        <Purpose />
      </div>

      <div id="gallery" className="gallery-section">
        <h1 className="gallery-heading">Image Gallery</h1>
          <ImageGallery />
    </div>

      <div id="contact">
        <Contact />
      </div>

    </div>
  );
};

export default App;